import { SET_OUTLETS, SET_CURRENT_OUTLET, OUTLETS_REQUEST } from './constants';

export function setOutlets(outlets) {
  return { type: SET_OUTLETS, payload: { outlets } };
}

export function outletsRequest() {
  return { type: OUTLETS_REQUEST, payload: {} };
}

export function setCurrentOutlet(data) {
  return { type: SET_CURRENT_OUTLET, payload: { data } };
}
